<div class="setting-container" [attr.data-testid]="testIds.settingContainer">
  <p class="setting-descriptor" [attr.data-testid]="testIds.settingDescriptor">
    {{ settingDescriptor() }}
  </p>
  <ng-content class="setting-info"></ng-content>
  <div class="item-container" [attr.data-testid]="testIds.itemContainer">
    <p
      [class.bold-text]="choiceDescriptor() === 'aktiv'"
      class="choice-descriptor"
      [attr.data-testid]="testIds.choiceDescriptor">
      {{ choiceDescriptor() }}
    </p>
    <mat-slide-toggle
      (change)="onChange($event.checked)"
      [checked]="modelNg()"
      [disabled]="disabled()"
      class="tim-slide-toggle"
      [attr.data-testid]="testIds.slideToggle"></mat-slide-toggle>
  </div>
</div>
